// PLAN-2 M4a — a general "open Mira addressed to an intent" bus.
//
// Any surface can ask Mira to open focused on a task without knowing where the
// launcher lives in the tree. This is deliberately GENERAL: M4a's "Review with
// Mira", M5's "Brief me", and every future skill in the matrix ride this same
// mechanism — an intent is just { type, ...payload }.
const listeners = new Set();

export function onMiraIntent(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function requestMiraIntent(intent) {
  // A single bad listener must never break the caller (or the other listeners).
  listeners.forEach((listener) => {
    try {
      listener(intent);
    } catch {
      /* swallow — a launcher that isn't mounted yet simply doesn't hear it */
    }
  });
}
